<script setup lang="ts">
import type { BlobHandlerDialogProvider } from './blob-handler-dialog';
import { useGlobalBlobHandlerDialog } from './blob-handler-dialog';
import DownloadBlob from './download-blob.vue';
import ViewBlobDialog from './view-blob-dialog.vue';

const props = defineProps<{
    provider?: BlobHandlerDialogProvider;
}>();
const _provider = props.provider || useGlobalBlobHandlerDialog();

</script>

<template>
    <div>
        <ViewBlobDialog
            v-model:url="_provider.viewerUrl"
            v-model:text="_provider.viewerText"
            :title="_provider.viewerTitle"
            @dialog-closed="_provider.viewerClosed"
        />
        <DownloadBlob
            :download-action="_provider.downloadAction"
            :download-params="_provider.downloadParams"
            :submit="_provider.downloadSubmit"
        />
    </div>
</template>
